import {
  CAT_CARD,
  CAT_CARD_FR,
  CAT_CREDIT,
  CAT_CREDITS_FR,
  CREDITS,
  CREDITS_FR,
  FR_LOCALE
} from '@app/constants/commonConstants';
import { useSelector } from 'react-redux';

const useGetCatFinancialTranslations = () => {
  const locale = useSelector(state => state?.common?.locale);
  const isFrench = locale === FR_LOCALE;
  const isCatCreditsTranslationsEnabled = useSelector(
    state => state.featureFlag?.PCC_CatCardCredits_translations
  );
  const catCreditsTranslation =
    isCatCreditsTranslationsEnabled && isFrench ? CAT_CREDITS_FR : CAT_CREDIT;

  const creditsTranslation =
    isCatCreditsTranslationsEnabled && isFrench ? CREDITS_FR : CREDITS;

  const catCardTranslation =
    isCatCreditsTranslationsEnabled && isFrench ? CAT_CARD_FR : CAT_CARD;

  return { catCreditsTranslation, creditsTranslation, catCardTranslation };
};

export default useGetCatFinancialTranslations;
